module.exports = __webpack_public_path__ + "img/assettrackingsigfoxdeviceprofile.73621a76.png";